import axios from 'axios';
import type { LandingPageConfig, LandingPageMap } from '../types/landingPage';
import { landingBase } from '../config/source';

/**
 * Fetch landing page configuration by subdomain, from the ERP or the ICP
 * (config/source.ts). This is a PUBLIC endpoint - no authentication required
 */
export async function fetchLandingPageBySubdomain(subdomain: string): Promise<LandingPageConfig> {
  const response = await axios.get<LandingPageConfig>(`${landingBase(subdomain)}/`);
  return response.data;
}

/**
 * Fetch the geo overlay for the landing-page impact map.
 * Returns generators (Kobo survey points) + collector stations.
 * Public endpoint, no PII.
 */
export async function fetchLandingPageMap(subdomain: string): Promise<LandingPageMap> {
  const response = await axios.get<LandingPageMap>(`${landingBase(subdomain)}/map/`);
  return response.data;
}
